/*
 * ******************************************************************************
 * Copyright Innov'ATM all rights reserved. This software is the property of
 * Innov'ATM and may not be used in any manner except under a license agreement
 * signed with Innov'ATM.
 * *******************************************************************************
 */
import { memo } from 'react';

import { ONE_HOUR } from '../../../../config/constants';
import { useRmsGanttValue } from '../RmsContext';
import { getGanttNbTimelineHours } from './gantt.utils';
import { GanttGridBox, GanttGridStepBox, GanttGridSubStepBox } from './GanttGrid.style';

export const GanttGrid = memo(() => {
    const { from, to } = useRmsGanttValue('dayBounds');
    const ganttNbTimelineHours = getGanttNbTimelineHours(from, to);
    //grid with step by half hour
    const hours = Array(ganttNbTimelineHours * 2)
        .fill(null)
        .map((_, i) => from + (i * ONE_HOUR) / 2);

    return (
        <GanttGridBox>
            {hours.map(hour => (
                <GanttGridStepBox key={hour}>
                    <GanttGridSubStepBox />
                    <GanttGridSubStepBox />
                    <GanttGridSubStepBox />
                    <GanttGridSubStepBox />
                    <GanttGridSubStepBox />
                    <GanttGridSubStepBox />
                </GanttGridStepBox>
            ))}
        </GanttGridBox>
    );
});
